"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashMessage = exports.hashCalldata = void 0;
var hash_1 = require("./utils/hash");
__exportStar(require("./ellipticalCurve"), exports);
function hashCalldata(calldata) {
    var calldataCopy = __spreadArray([], __read(calldata), false);
    if (calldataCopy.length === 0) {
        return '0';
    }
    if (calldataCopy.length === 1) {
        return calldataCopy[0];
    }
    // calldata element will always be there as it was checked by an if statement before (!)
    var calldataEl = calldataCopy.shift();
    return (0, hash_1.pedersen)([hashCalldata(calldataCopy), calldataEl]);
}
exports.hashCalldata = hashCalldata;
function hashMessage(account, to, selector, calldata, nonce) {
    var hash0 = (0, hash_1.pedersen)([account, to]);
    var hash1 = (0, hash_1.pedersen)([hash0, selector]);
    var calldataHash = hashCalldata(calldata);
    var hash2 = (0, hash_1.pedersen)([hash1, calldataHash]);
    return (0, hash_1.pedersen)([hash2, nonce]);
}
exports.hashMessage = hashMessage;
